"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (existingSwapHistory, importedSwapHistory) => {
    const usedSwapIds = [];
    const dirtyJoin = [...(existingSwapHistory || []), ...(importedSwapHistory || [])];
    const cleanSwapHistory = [];
    for (let i = dirtyJoin.length - 1; i >= 0; i--) {
        // Iterate backwards to prioritise imported swaps
        const swapOperation = dirtyJoin[i];
        if (usedSwapIds.includes(swapOperation.swapId))
            continue;
        usedSwapIds.push(swapOperation.swapId);
        cleanSwapHistory.push(swapOperation);
    }
    return cleanSwapHistory;
};
//# sourceMappingURL=joinSwapHistories.js.map